import { useQuery } from "@tanstack/react-query";
import { getSearchFields } from "../../../services/report";

export function useManualSearchFormData() {
  const {
    data: searchFieldsData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["manual-search", "fields"],
    queryFn: getSearchFields,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return { searchFieldsData, isLoading, isError };
}
